export default "__VITE_ASSET__BWUeaRm9__"